import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { CreateCRL as CreateCRLReq } from "../../../routes/cryptography";
import FileDownload from "js-file-download";
import { Buffer } from "buffer"


class CreateCRL extends Component {
    constructor() {
        super();
        this.state = {
            dataCRL: {
                dataCert: "",
                privKey: "",
                pass: "",
                status: "",

            },
            certFileName: "файл",
            privKeyFileName: "файл",
            certsFileIsOpen: false,
            privKeyFileIsOpen: false,

            isValidCertFileSize: true,
            isValidPrivKeyFileSize: true,

            errors: {},
        };
        this.handleFilePrivKeyChange = this.handleFilePrivKeyChange.bind(this);
        this.handleFileCertChange = this.handleFileCertChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

    }

    componentDidMount() { }

    handleInputChange(e) {
        //console.log(e.target.value);
        try {

            this.setState({
                dataCRL: {
                    ...this.state.dataCRL,
                    pass: e.target.value,
                },
            });
        } catch (error) {
            //console.log(error);
        }
    }


    handleFileCertChange() {
        try {
            const file = document.getElementById("fileCert").files[0];
            //console.log(file);

            if (file !== undefined && file.size < 20000000) {
                this.setState({ certFileName: file.name, isValidCertFileSize: true, certsFileIsOpen: true });
                var reader = new FileReader();
                reader.readAsArrayBuffer(file);
                reader.onload = () => {
                    const buffer = reader.result;

                    const data = new Buffer(new Uint8Array(buffer)).toString();
                    this.setState({
                        dataCRL: { ...this.state.dataCRL, dataCert: data },
                    });
                    //console.log(data);
                };
                reader.onerror = (e) => {
                    console.error(e);
                };
            } else {
                this.setState({ certFileName: "файл", isValidCertFileSize: false, certsFileIsOpen: false });
            }
        } catch (error) {
            //console.log(error);
        }
    }
    handleFilePrivKeyChange() {
        try {
            const file = document.getElementById("filePrivKey").files[0];
            //console.log(file);

            if (file !== undefined && file.size < 20000000) {
                this.setState({ privKeyFileName: file.name, isValidPrivKeyFileSize: true, privKeyFileIsOpen: true });
                var reader = new FileReader();
                reader.readAsArrayBuffer(file);
                reader.onload = () => {
                    const buffer = reader.result;

                    const data = new Buffer(new Uint8Array(buffer)).toString();
                    // const data1 = new Buffer(new Uint8Array(buffer)).toString();

                    this.setState({
                        dataCRL: { ...this.state.dataCRL, privKey: data },
                    });
                    //console.log(data);
                    // console.log(data1);
                };
                reader.onerror = (e) => {
                    console.error(e);
                };
            } else {

                this.setState({ privKeyFileName: "файл", isValidPrivKeyFileSize: false, privKeyFileIsOpen: false });
            }
        } catch (error) {
            //console.log(error);
        }
    }


    handleSubmit(e) {
        e.preventDefault();
        try {
            //console.log(`Cert: ${this.state.dataCRL.dataCert}`);
            //console.log(`Key: ${this.state.dataCRL.privKey}`);
            //console.log(`Pass: ${this.state.dataCRL.pass}`);

            CreateCRLReq(
                this.state.dataCRL.dataCert,
                this.state.dataCRL.privKey,
                this.state.dataCRL.pass
            ).then((result) => {
                try {
                    //console.log(result);
                    try {
                        //console.log(result);
                        if (result.status === 200) {
                            FileDownload(result.data.crl, "crl.pem");
                            document.getElementById("view").style.borderColor = "green";
                        } else {
                            document.getElementById("view").style.borderColor = "red";

                            this.setState({
                                status: "Ошибка создания СОС",
                            });
                        }
                    } catch (error) {
                        //console.log(error);
                        document.getElementById("view").style.borderColor = "red";

                        this.setState({
                            status: "Ошибка создания СОС",
                        });
                    }
                } catch (error) {
                    //console.log(error);
                }
            });
        } catch (error) {
            //console.log(error);
        }
    }

    render() {
        return (
            <div className="container">
                <h4 className="major">Создание СОС</h4>
                <Form onSubmit={this.handleSubmit}>
                    <div className="sm-4">
                        <Form.Group
                            style={{ paddingBottom: "20px", borderBottom: "1px solid white" }}
                        >
                            <Form.Label>Выберите сертификат</Form.Label>
                            <Form.File custom>
                                <Form.File.Input
                                    id="fileCert"
                                    onChange={this.handleFileCertChange}
                                    isValid={this.state.certsFileIsOpen}
                                    isInvalid={!this.state.isValidCertFileSize}

                                />
                                <Form.File.Label data-browse="Выбрать">
                                    {this.state.certFileName}
                                </Form.File.Label>
                                <Form.Control.Feedback type="valid" />
                                <Form.Control.Feedback type="invalid">
                                    максимальный размер файла 20мб
                                </Form.Control.Feedback>
                            </Form.File>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Выберите личный ключ</Form.Label>
                            <Form.File custom>
                                <Form.File.Input
                                    id="filePrivKey"
                                    onChange={this.handleFilePrivKeyChange}
                                    isValid={this.state.privKeyFileIsOpen}
                                    isInvalid={!this.state.isValidPrivKeyFileSize}

                                    required
                                />
                                <Form.File.Label data-browse="Выбрать">
                                    {this.state.privKeyFileName}
                                </Form.File.Label>
                                <Form.Control.Feedback type="valid" />
                                <Form.Control.Feedback type="invalid">
                                    максимальный размер файла 20мб
                                </Form.Control.Feedback>
                            </Form.File>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Введите пароль</Form.Label>
                            <Form.Control
                                id="password"
                                onChange={this.handleInputChange}
                                type="password"
                                placeholder="Пароль"
                                style={{ color: 'white' }}
                            />
                        </Form.Group>
                        <Form.Label style={{ float: "left" }}>
                            {this.state.dataCRL.status}
                        </Form.Label>
                        <Button
                            style={{ float: "right" }}
                            variant="success"
                            type="submit"
                            size="sm"
                        >
                            Создать СОС
                        </Button>
                    </div>
                </Form>
            </div>
        );
    }
}
export default connect()(withRouter(CreateCRL));
